import { Component, OnInit } from '@angular/core';
import { AdminServiceService } from '../../service/admin-service.service';

@Component({
  selector: 'app-store-stats',
  templateUrl: './store-stats.component.html',
  styleUrls: ['./store-stats.component.scss'],
})
export class StoreStatsComponent implements OnInit {
  public stores = [];
  public totalPages = undefined;
  private _page = 1;

  constructor(
    private adminSv: AdminServiceService
  ) { }

  ngOnInit() {
    this.getStores();
  }

  async getStores(){
    const res = await this.adminSv.getStats('indexStore', this._page);
    if(!this.totalPages){
      this.totalPages = res.meta.last_page;
    }
    const stores: any[] = res.data;
    this.stores = stores.map(x => {
      x.name = x.business_name;
      x.media = x.logo
      return x;
    });
    console.log(this.stores);
  }

  async changePage(ev){
    this._page = ev;
    await this.getStores();
  }
}
